// tslint:disable
export enum CampaignCommunicationType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description SMS
     */
    SMS = 10002,
    /**
     * @description EMAIL
     */
    EMAIL = 10003,
    /**
     * @description PHONE OUTBOUND
     */
    PHOUT = 10004,
    /**
     * @description PHONE INBOUND
     */
    PHIN = 10005,
    /**
     * @description FAX
     */
    FAX = 10006,
    /**
     * @description LETTER
     */
    LETTER = 10007,
    /**
     * @description 24-Hour SMS
     */
    SMS24 = 10008,
    /**
     * @description PDF
     */
    PDF = 10009,
    /**
     * @description 20166
     */
    Two0166 = 10010,
    /**
     * @description Document Send
     */
    DocumentSend = 10011,
    /**
     * @description Data Feed
     */
    DataFeed = 10012,
    /**
     * @description Mango Message
     */
    MANGO = 10013,
    /**
     * @description TC-Script
     */
    TCScript = 10014,
    /**
     * @description Physical Collateral
     */
    PhysicalCollateral = 10015,
    /**
     * @description PDF To Folder
     */
    PDFToFolder = 10016,
    /**
     * @description Simulated SMS
     */
    SimulatedSMS = 10017,
    /**
     * @description DocuSign
     */
    DocuSign = 10018,
    /**
     * @description EPAM SMS streams
     */
    EPAMApi128 = 10019,
    /**
     * @description EPAM non-SMS streams
     */
    EPAMApi24 = 10020,
    /**
     * @description Triage To Pharmacy - Fax
     */
    T2PFAX = 10021,
    /**
     * @description API
     */
    API = 10022,
    /**
     * @description Special
     */
    Special = 10023,
    /**
     * @description VDC PDF
     */
    VDCPDF = 10024,
    /**
     * @description VDC FAX
     */
    VDCFAX = 10025,
}
(CampaignCommunicationType as any)['TWO0166'] = 10010;
(CampaignCommunicationType as any)['DOCUMENTSEND'] = 10011;
(CampaignCommunicationType as any)['DATAFEED'] = 10012;
(CampaignCommunicationType as any)['TCSCRIPT'] = 10014;
(CampaignCommunicationType as any)['PHYSICALCOLLATERAL'] = 10015;
(CampaignCommunicationType as any)['PDFTOFOLDER'] = 10016;
(CampaignCommunicationType as any)['SIMULATEDSMS'] = 10017;
(CampaignCommunicationType as any)['DOCUSIGN'] = 10018;
(CampaignCommunicationType as any)['EPAMAPI128'] = 10019;
(CampaignCommunicationType as any)['EPAMAPI24'] = 10020;
(CampaignCommunicationType as any)['SPECIAL'] = 10023;
